import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import StepsBar from './StepsBar'
import useStep from '../../../hooks/useStep'

const steps = [
  {
    text: <FormattedMessage id='select_your_trip' defaultMessage='Select your trip' />,
    shortText: <FormattedMessage id='trip' defaultMessage='Trip' />,
  },
  {
    text: <FormattedMessage id='select_your_cabin' defaultMessage='Select your cabin' />,
    shortText: <FormattedMessage id='cabin' defaultMessage='Cabin' />,
  },
  {
    text: <FormattedMessage id='add_extras' defaultMessage='Add Extras' />,
    shortText: <FormattedMessage id='extras' defaultMessage='Extras' />,
  },
  {
    text: <FormattedMessage id='review_book' defaultMessage='Review & book' />,
    shortText: <FormattedMessage id='review' defaultMessage='Review' />,
  },
]

StepsProgressBar.propTypes = {
  currency: PropTypes.string,
}

export default function StepsProgressBar({ currency }) {
  const { step, setStep } = useStep()
  return (
    <StepsBar
      steps={steps}
      currentStep={step}
      setStep={setStep}
      currency={currency}
    />
  )
}
